import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { db, storage } from "../firebase";

const areas = ["Software Engineering", "Artificial Intelligence", "Digital Products", "Technology Operations"];

export default function CrovianBrief() {
  const [area, setArea] = useState("");
  const [project, setProject] = useState("");
  const [document, setDocument] = useState(null);
  const [nda, setNda] = useState(null);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: "", message: "" });

  const upload = async (file) => {
    if (!file) return null;
    const fileRef = ref(storage, `quotes/${Date.now()}-${file.name}`);
    await uploadBytes(fileRef, file);
    return getDownloadURL(fileRef);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setStatus({ type: "", message: "" });
    try {
      const [documentUrl, ndaUrl] = await Promise.all([upload(document), upload(nda)]);
      await addDoc(collection(db, "quotes"), {
        service: area,
        project: project.trim(),
        documentUrl,
        ndaUrl,
        createdAt: serverTimestamp(),
        source: "crovian-website",
      });
      setArea("");
      setProject("");
      setDocument(null);
      setNda(null);
      setStatus({ type: "success", message: "Thank you. Your project brief has been received." });
    } catch (error) {
      console.error("Project brief submission failed:", error);
      setStatus({ type: "error", message: "We couldn't submit the brief. Please try again." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="brief-page">
      <Helmet>
        <title>Project Brief — Crovian Technologies</title>
        <meta name="description" content="Share your software, AI or digital product requirements with Crovian Technologies." />
      </Helmet>
      <section className="brief-intro section-pad">
        <p className="eyebrow">Project brief / Crovian</p>
        <h1>SHARE THE<br />OPPORTUNITY.</h1>
        <p>A concise brief is enough. Include supporting documents only when they help explain the system.</p>
      </section>
      <section className="brief-layout section-pad">
        <div className="brief-step"><span>01</span><p>Choose a business area and describe what needs to be built, improved or modernized.</p></div>
        <form className="contact-form brief-form" onSubmit={handleSubmit}>
          <fieldset>
            <legend>Business area</legend>
            <div className="area-options">
              {areas.map((item) => (
                <label className={area === item ? "is-selected" : ""} key={item}>
                  <input type="radio" name="area" value={item} checked={area === item} onChange={(event) => setArea(event.target.value)} required />
                  <span>{item}</span>
                </label>
              ))}
            </div>
          </fieldset>
          <label>Project requirements<textarea rows="8" maxLength="2000" value={project} onChange={(event) => setProject(event.target.value)} required /></label>
          <div className="file-grid">
            <label className="file-field">Supporting document<input type="file" onChange={(event) => setDocument(event.target.files[0] || null)} /><span>{document?.name || "Choose file"}</span></label>
            <label className="file-field">NDA (optional)<input type="file" onChange={(event) => setNda(event.target.files[0] || null)} /><span>{nda?.name || "Choose file"}</span></label>
          </div>
          {status.message && <p className={`form-status form-status--${status.type}`} role="status">{status.message}</p>}
          <button className="submit-button" type="submit" disabled={loading}>{loading ? "Submitting…" : "Submit brief"}<span aria-hidden="true">→</span></button>
          <p className="form-note">Files are stored securely with the existing project Firebase integration.</p>
        </form>
      </section>
    </main>
  );
}
